<template>
  <v-app>
    <v-main class="d-flex align-center justify-center">
      <router-view v-if="shouldRedirect" />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    token: null,
  }),
  computed: {
    ...mapGetters('user', ['user']),

    shouldRedirect() {
      // Only the scheduler editor needs the user profile; public pages
      // (booking, not-found fallback) render immediately
      return this.$route.name === 'scheduler' ? this.user : true
    },
  },
  methods: {
    ...mapActions('user', ['fetchUser']),
  },
  watch: {
    '$route.query.token': {
      async handler(token) {
        if (token) {
          localStorage.setItem('token', token)

          await this.fetchUser()

          // Strip only the token — keep other params (e.g. mailboxId deep link)
          const rest = { ...this.$route.query }
          delete rest.token
          this.$router.replace({ query: rest })
        }
      },
      immediate: true,
    },
  },
  created() {
    console.log('App created', process.env.VUE_APP_SYMBO_API_URL)
  },
  mounted() {
    if (localStorage.getItem('token')) {
      this.fetchUser()
    }
  },
}
</script>
